import { formatLoggerData, logger } from 'services/logger';
import type { PriceZonesResult } from 'services/api/pay';

let defaults: Record<string, unknown> = {
  defaultPriceZone: null,
  defaultSource: null,
  defaultCurrency: null,
  defaultCurrencySource: null,
};

/** 保留后端原始默认值，避免与页面实际选中的方案/币种混淆。 */
export function setPricingLogDefaults(data: PriceZonesResult) {
  defaults = {
    defaultPriceZone: data.defaultPriceZone ?? null,
    defaultSource: data.defaultSource ?? null,
    defaultCurrency: data.defaultCurrency ?? null,
    defaultCurrencySource: data.defaultCurrencySource ?? null,
  };
}

export function logPricing(event: string, data: Record<string, unknown>, error?: unknown) {
  const failure = error as
    | {
        message?: string;
        code?: string;
        response?: { status?: number; data?: { code?: unknown; message?: string; msg?: string } };
      }
    | undefined;
  const details = {
    ...defaults,
    ...data,
    ...(error !== undefined && {
      errorMessage: failure?.message ?? String(error),
      errorCode: failure?.response?.data?.code ?? failure?.code,
      httpStatus: failure?.response?.status,
      serverMessage: failure?.response?.data?.message ?? failure?.response?.data?.msg,
    }),
  };
  const message = `[pricing][${event}] ${formatLoggerData(details)}`;
  if (error !== undefined) {
    logger.error(message);
  } else {
    logger.info(message);
  }
}
